import { render, staticRenderFns } from "./ElSelectClassic.vue?vue&type=template&id=1d938ef7"
import script from "./ElSelectClassic.vue?vue&type=script&lang=js"
export * from "./ElSelectClassic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports